import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full p-input-icon-left" }

import { onMounted, ref } from 'vue';
import ActivityAttendanceChart from './ActivityAttendanceChart.vue';
import ActivityAttendanceCalendarList from './ActivityAttendanceCalendarList.vue';
import { useAttendanceStore } from '@/store';
import { useRouting } from '@/composables';
import { useDateTime } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityAttendance',
  setup(__props) {

const dates = ref([]);
const AttendanceStore = useAttendanceStore();
const $routing = useRouting();

onMounted(() => init());

const init = async () => {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  const start = new Date(year, month, 1);
  const end = new Date(year, month, 28);

  dates.value = [start, end];

  const startDate = useDateTime().formatDateForApi(start);
  const endDate = useDateTime().formatDateForApi(end);

  AttendanceStore.setDates(startDate, endDate);
  await AttendanceStore.getAttendanceResults(Number($routing.route.params.id));
  await AttendanceStore.getTherapyResults(Number($routing.route.params.id), startDate, endDate);
};

const onDateRangeChange = async (event) => {
  const startDate = event[0] ? useDateTime().formatDateForApi(event[0]) : null;
  const endDate = event[1] ? useDateTime().formatDateForApi(event[1]) : null;

  if (startDate && endDate) {
    AttendanceStore.setDates(startDate, endDate);
    await AttendanceStore.getAttendanceResults(Number($routing.route.params.id));
    await AttendanceStore.getTherapyResults(Number($routing.route.params.id), startDate, endDate);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_AppDateRangePicker = _resolveComponent("AppDateRangePicker")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "page-content-half flex flex-column" }, {
    header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("h2", null, "Attendance", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_IconField, { "icon-position": "left" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputIcon, {
              class: "p-input-icon-left",
              style: {"z-index":"100"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  name: "calendar_today",
                  class: "text-lg z-1"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_AppDateRangePicker, {
              modelValue: dates.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dates).value = $event)),
              class: "w-full",
              value: dates.value,
              onChange: onDateRangeChange
            }, null, 8, ["modelValue", "value"])
          ]),
          _: 1
        })
      ]),
      _createVNode(ActivityAttendanceChart),
      _createVNode(ActivityAttendanceCalendarList)
    ]),
    _: 1
  }))
}
}

})